import { render, staticRenderFns } from "./SelectRegion.vue?vue&type=template&id=02984f73&"
import script from "./SelectRegion.vue?vue&type=script&lang=js&"
export * from "./SelectRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports